

























































import {
    computed,
    defineComponent,
    onMounted,
    ref,
    Ref,
    watch,
} from '@vue/composition-api';

const urlSuffixReg = /[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;

export default defineComponent({
    name: 'input-url',
    props: {
        width: {
            type: String,
            default: '280',
        },
        height: {
            type: String,
            default: '28',
        },
        name: {
            type: String,
        },
        required: {
            type: Boolean,
            default: true,
        },
        maxLen: {
            type: Number,
            default: 524288,
        },
        minLen: {
            type: Number,
            default: 1,
        },
        value: {
            type: String,
            default: '',
        },
        check: {
            type: Boolean,
            default: true,
        },
        status: {
            type: String,
        },
    },
    model: {
        prop: 'value',
        event: 'update',
    },
    setup(props, context) {
        const selectList = ['https://', 'http://'];
        const select = ref(
            // eslint-disable-next-line no-nested-ternary
            props.value
                ? props.value.startsWith('http://')
                    ? 'http://'
                    : 'https://'
                : selectList[0],
        );
        const inputWrap: Ref<any> = ref(null);
        const inputVal = computed({
            get: () => {
                return props.value.startsWith('http://')
                    ? props.value.substr(7)
                    : props.value.substr(8);
            },
            set: (val) => {
                context.emit('update', val ? `${select.value}${val}` : '');
                context.root.$nextTick(() => {
                    context.emit('update-input', val);
                });
            },
        });
        watch(
            () => select.value,
            (val) => {
                if (inputVal.value) {
                    context.emit('update', `${val}${inputVal.value}`);
                }
                context.root.$nextTick(() => {
                    context.emit('update-select', val);
                });
            },
        );
        function checkUrl() {
            context.emit('blur', `${select.value}${inputVal.value}`);
            if (!props.check) return;
            const inputInner = inputWrap.value.querySelectorAll(
                '.el-input__inner',
            ) as HTMLElement[];
            const inputSeclect = inputInner[0];
            const input = inputInner[1];
            const errorWrap = inputWrap.value.querySelector('.errWrap');
            if (!urlSuffixReg.test(inputVal.value.trim())) {
                if (input.dataset.hasError) {
                    return;
                }
                const error = document.createElement('div');
                error.classList.add('input-text-tip-error');
                error.innerHTML = '格式错误';
                (errorWrap as Element).appendChild(error);
                input.dataset.hasError = 'urlSuffixError';
                error.classList.add('show-text-tip-error');
                input.classList.add('input-text-error');
                inputSeclect.classList.add('input-text-error');
                return;
            }
            if (input.dataset.hasError) {
                delete input.dataset.hasError;
                input.classList.remove('input-text-error');
                inputSeclect.classList.remove('input-text-error');
                (errorWrap as Element).removeChild(errorWrap.firstChild);
            }
        }

        return {
            inputVal,
            select,
            selectList,
            checkUrl,
            inputWrap,
        };
    },
});
